import React from 'react';
import { Lock } from 'react-huge-icons/outline';

interface DisabledOverlayProps {
  disabled: boolean;
  children: React.ReactNode;
}

const DisabledOverlay = ({ disabled, children }: DisabledOverlayProps) => {
  return (
    <div className="relative">
      {children}
      {disabled && (
        <div className="absolute inset-0 animate-fadeIn cursor-not-allowed">
          {/* Блокировка с полупрозрачным оверлеем */}
          <div className="absolute inset-0 bg-[linear-gradient(135deg,#ff6b6b22_25%,transparent_25%),linear-gradient(225deg,#ff6b6b22_25%,transparent_25%),linear-gradient(315deg,#ff6b6b22_25%,transparent_25%),linear-gradient(45deg,#ff6b6b22_25%,transparent_25%)] bg-[length:20px_20px] opacity-30 rounded-xl" />
          <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm rounded-xl" />
          {/* Заблокированная иконка */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-textsecondary opacity-80 drop-shadow-lg">
              <Lock className="w-44 h-44 text-white" />
            </div>
          </div>
          
        </div>
      )}
    </div>
  );
};

export default DisabledOverlay;